import { Header, Page, PageContent } from "@/components/page";
import { getPaymentFromSessionStorage } from "@/features/payment/utils";
import { getShopFromLocalStorage } from "@/hooks/use-shop";
import { getToken } from "@/hooks/use-token";
import {
  createFileRoute,
  Link,
  redirect,
  useNavigate,
} from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { useAudioSlot } from "@/features/audio/kiosk-audio";

export const Route = createFileRoute("/invoice-question-screen")({
  component: RouteComponent,
  loader: () => {
    const payment = getPaymentFromSessionStorage();
    if (!payment) {
      throw redirect({
        to: "/start-screen",
        reloadDocument: true,
      });
    }
    const token = getToken();
    const shop = getShopFromLocalStorage();
    if (token || payment.price === 0 || !shop?.canGenerateInvoices) {
      throw redirect({
        to: "/bubbles-loves-you-screen",
      });
    }
    return payment!;
  },
});

function RouteComponent() {
  useAudioSlot("page.invoice-question");
  const payment = Route.useLoaderData();
  const navigate = useNavigate();
  const [counter, setCounter] = useState(30);

  useEffect(() => {
    const interval = setInterval(() => {
      setCounter((prev) => {
        if (prev === 0) {
          clearInterval(interval);
          navigate({
            to: "/bubbles-loves-you-screen",
          });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Page>
      <Header></Header>
      <PageContent>
        <div className="relative w-full mx-4">
          <div className="relative bg-white rounded-2xl border-2 border-[#2E7D9A] p-8 shadow-lg">
            <h2 className="text-[#2E7D9A] text-xl font-semibold text-center mb-4 leading-tight">
              <Trans>Szeretnél számlát kérni ehhez a tranzakcióhoz?</Trans>
            </h2>

            <p className="text-[#FF7043] text-center mb-8 font-medium">
              <Trans>Automatikus folytatás:</Trans> {counter}
              <Trans>mp</Trans>
            </p>

            <div className="flex gap-4">
              <Link
                to={"/invoice-generation-screen/$nonce"}
                params={{ nonce: payment.kioskPaymentNonceKey }}
                onClick={() => {}}
                className="flex-1 bg-[#2E7D9A] text-center text-white py-3 px-6 rounded-lg font-medium hover:bg-[#1E5F73] transition-colors duration-200 text-sm"
              >
                <Trans>Igen, számla generálása</Trans>
              </Link>

              <Link
                to={"/bubbles-loves-you-screen"}
                onClick={() => {}}
                className="flex-1 bg-[#6B7280]  text-center text-white py-3 px-6 rounded-lg font-medium hover:bg-[#4B5563] transition-colors duration-200 text-sm"
              >
                <Trans>Nem, számla kihagyása</Trans>
              </Link>
            </div>
          </div>
        </div>
      </PageContent>
    </Page>
  );
}
